import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { Add, Upload } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ComoButton } from "../Common/ComoButton";

interface ActionButtonsProps {
  onCreate: () => void;
  onImport: (file: File) => void;
  isLoading: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onCreate,
  onImport,
  isLoading,
}) => {
  const { t } = useTranslation("myQuestionLists");

  const handleFileInput = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.onchange = (event) => {
      const target = event.target as HTMLInputElement;
      const file = target?.files?.[0];
      if (file) {
        onImport(file);
      }
    };
    input.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <ComoButton onClick={onCreate} startIcon={<Add />}>
        {t("myQuestionLists.actionButtons.createNewList")}
      </ComoButton>
      <ComoButton
        onClick={handleFileInput}
        secondary
        startIcon={isLoading ? null : <Upload />}
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularProgress size={20} />
        ) : (
          t("myQuestionLists.actionButtons.importListJson")
        )}
      </ComoButton>
    </Box>
  );
};

export default ActionButtons;
